module.exports = __webpack_public_path__ + "eid2.png?ecddf54de72abe6e715c4a5be2c3487c";


//////////////////
// WEBPACK FOOTER
// ./public/img/memories/eid2.png
// module id = 573
// module chunks = 1